var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1098_2128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13C16.3438 13 15 14.3438 15 16V26C15 27.6562 16.3438 29 18 29H27H28C28.5531 29 29 28.5531 29 28C29 27.4469 28.5531 27 28 27V25C28.5531 25 29 24.5531 29 24V14C29 13.4469 28.5531 13 28 13H27H18ZM18 25H26V27H18C17.4469 27 17 26.5531 17 26Cnan nan 17.4469 25 18 25ZM19 17.5C19 17.225 19.225 17 19.5 17H25.5C25.775 17 26 17.225 26 17.5Cnan nan 25.775 18 25.5 18H19.5C19.225 18 19 17.775 19 17.5ZM19.5 19H25.5C25.775 19 26 19.225 26 19.5Cnan nan 25.775 20 25.5 20H19.5C19.225 20 19 19.775 19 19.5Cnan nan 19.225 19 19.5 19Z",
    fill: "#092E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1098_2128",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1098_2128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1098_2128",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveFiles);
export default __webpack_public_path__ + "static/media/ic_active_files.793594111db96fb1401ada921edbdac9.svg";
export { ForwardRef as ReactComponent };